import { rem } from '@innovyze/stylovyze';
import React, { SVGProps } from 'react';
import styled from 'styled-components';

const Container = styled.div`
	margin-right: ${rem(5)};
`;

interface FileUploadOutlineIconProps extends SVGProps<SVGSVGElement> {
	color?: string;
}

export default function FileUploadOutlineIcon({
	color,
	...props
}: FileUploadOutlineIconProps) {
	return (
		<Container>
			<svg
				width={20}
				height={20}
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}>
				<path
					d="M11.667 1.667l5 5v10A1.666 1.666 0 0115 18.333H5a1.667 1.667 0 01-1.667-1.666V3.333A1.667 1.667 0 015 1.667h6.667zm3.333 15V7.5h-4.167V3.333H5v13.334h10zM10 10l3.333 3.333H11.25v2.5h-2.5v-2.5H6.667L10 10z"
					fill={color || '#768D95'}
				/>
			</svg>
		</Container>
	);
}
